webpackJsonp([70144966829960],{

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContactModule = __webpack_require__(353);
	
	var _ContactModule2 = _interopRequireDefault(_ContactModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contact = function (_Component) {
	  _inherits(Contact, _Component);
	
	  function Contact() {
	    _classCallCheck(this, Contact);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Contact.prototype.render = function render() {
	    var content = this.props.data.content;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _ContactModule2.default.Contact },
	      _react2.default.createElement('div', {
	        className: _ContactModule2.default.content,
	        dangerouslySetInnerHTML: { __html: content }
	      })
	    );
	  };
	
	  return Contact;
	}(_react.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Contact":"src-components-Contact----Contact-module---Contact---1kHFP","content":"src-components-Contact----Contact-module---content---jChpK"};

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Contact = __webpack_require__(240);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_React$Component) {
	  _inherits(ContactPage, _React$Component);
	
	  function ContactPage() {
	    _classCallCheck(this, ContactPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ContactPage.prototype.render = function render() {
	    var pageData = this.props.data.allWordpressPage.edges[0].node;
	    return _react2.default.createElement(_Contact2.default, { data: pageData });
	  };
	
	  return ContactPage;
	}(_react2.default.Component);
	
	exports.default = ContactPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-1a48d44ead10e227c4d4.js